const initialOrder = {
    orders: [],
    paymentnotcompletedorders : [],
    singleorders: [],
    ordermessages : {}
};

const orderReducer = (order = initialOrder, action) => {
    switch (action.type) {
        case 'GET_ORDER':
            return {
                ...order, orders: action.payload.data
            };
        case 'GET_PAYMENT_NOT_COMPLETED_ORDER':
            return {
                ...order, paymentnotcompletedorders: action.payload.data
            };
        case "ADD_ORDER":
            return {
                ...order, ordermessages: action.payload.data
            };
        case "UPDATE_ORDER":
            return {
                ...order, ordermessages: action.payload.data
            };
        case "UPDATE_ORDER_QTY":
            return {
                ...order, ordermessages: action.payload.data
            };
        case "DELETE_ORDER":
            return {
                ...order, ordermessages: action.payload.data
            };   
        case "GET_SINGLE_ORDER":
            return {
                ...order, singleorders: action.payload.data
            };
        case "UPDATE_ORDER_STATUS":
            return {
                ...order, ordermessages: action.payload.data
            };  
        case "STATUS_ORDER_RECEIVE":
            return{
                ...order, ordermessages: action.payload.data
            };
        case "ORDER_PENDING_REASON":
            return{
                ...order, ordermessages: action.payload.data
            } 
       
        default:return order;

    }
}
export default orderReducer;